import NavbarPc from './pc'
import NavbarMb from './mb'
import BottomBar from './bottomBar'
import BackHeader from './backHeader'
import React from 'react'
import { Context,XtLocale,Cookie,Request,Util,Storage } from "@xt/xtbase";
const {XtContext} = Context;
const {setHeader,XtAxios,XtAxios4} = Request;
const {getUrl,getUUID,doRsaEncrypt,getExplore,getPlatform} = Util;
import styles from "./index.module.less";

const Header = (props) => {
  const intl = XtLocale.intl;
  var langCode = intl.code;
  const [appState, appDispatch] = React.useContext(XtContext);
  const handleThemeToggle = () => {
    var newTheme = appState.theme == "dark" ? "light" : "dark";
    Cookie.set("theme", newTheme);
    appDispatch({
      payload: {
        theme: newTheme
      },
    });
  };
  const handleLangChange = (obj) => {
    if(obj.key == intl.locale)
      return;
    Cookie.set("lang", obj.code);
    Cookie.set("langManual", "1");
    setHeader({lang:obj.code});
    appDispatch({
      payload: {
        lang: obj.key,
      },
    });
    //XtAxios.put(Util.getOrigin("www") + "/xt-app/public/app-client/language", null, {data: { language: obj.code }});
    const langPath = XtLocale.getLangPath();
    if(langPath)
      location.href = "/"+obj.key+XtLocale.getLeftPath();
    else
      location.reload();
  };
  const handleAssistChange = (obj) => {
    Cookie.set("currency", obj.key);
    appDispatch({
      payload: {
        currency: obj.key,
      },
    });
  };

  const doLogout = ()=>{
    XtAxios.get(Util.getOrigin("www") + "/uaapi/uaa/authorize/token/revoke").then(() => {
        Storage.remove("token");
        Cookie.remove("token");
        Storage.remove("bindGoogleTip");
        Storage.remove("otcFiat");
        //location.href = getUrl("/");
        location.reload();
      })
      .catch(() => {})
      .finally(() => {});
  }

  const doChangeAccount = (userInfo)=>{
    if(userInfo.userAccountLevel == 1 && userInfo.existSubAccount)
    {
      location.href = getUrl("/account/sub/index");
      return;
    }
    const deviceId = Storage.get("client-device-id") || getUUID();
    if (deviceId && !Storage.get("client-device-id")) Storage.set("client-device-id", deviceId);
    XtAxios.post(Util.getOrigin("www") + "/uaapi/uaa/authorize/passwd/publicKey", {}, {
      errorPop: true,
    }).then((res) => {
      XtAxios.post(Util.getOrigin("www") + "/uaapi/uaa/account/switch", {
        accessToken:Cookie.get("token")
      },{
        headers:{
          "client-device-id": doRsaEncrypt(res.publicKey, deviceId),
          "client-device-name": `${getExplore()} (${getPlatform()})`,
        },
        errorPop:(message,data)=>{
          if(data.code == 401)
            location.href = getUrl("/accounts/login");
        }
      }).then((res) => {
        Cookie.set("token", res.accessToken);
        Storage.set("token", res.accessToken);
        location.href = getUrl("/account/sub/index");
      });
    });
  }

  // 如果启用底部 bar 模式：默认顶部仍为 NavbarMb + 底部 BottomBar；bottomBarHideTop 时仅保留 BottomBar（如 /convert/buy、/aicopy）
  if (props.bottomBar) {
    if (props.bottomBarHideTop) {
      return <BottomBar {...props} />;
    }
    return (
      <>
        <div className={`${styles['app-navbar']} ${styles['bottomBar-mode']} ${props.mode=="fixed"?styles.navbarZero:''}`} lang={langCode}>
          <NavbarMb {...props} onLocale={handleLangChange} onTheme={handleThemeToggle} onAssist={handleAssistChange} doLogout={doLogout} doChangeAccount={doChangeAccount}/>
        </div>
        <BottomBar {...props} />
      </>
    );
  }

  return (
    <div className={`${styles['app-navbar']} ${props.mode=="fixed"?styles.navbarZero:''}`} lang={langCode}>
      <NavbarPc {...props} onLocale={handleLangChange} onTheme={handleThemeToggle} onAssist={handleAssistChange} doLogout={doLogout} doChangeAccount={doChangeAccount}/>
      <NavbarMb {...props} onLocale={handleLangChange} onTheme={handleThemeToggle} onAssist={handleAssistChange} doLogout={doLogout} doChangeAccount={doChangeAccount}/>
    </div>
  )
}

export default Header
export { BackHeader }
export { default as GlobalHeader } from './globalHeader'
export {
  buildProductNav,
  buildAssetsMenu,
  buildProfileMenu,
  DEPOSIT_HREF,
  PROFILE_LOGOUT_ICON,
} from './config/productNav'
export { default as assistConfig } from './config/assistConfig'
export * from './globalHeader/navIcons'
export { NavStoreProvider } from './NavStoreContext'
export { default as AccountShell, AccountPageHeader } from './accountShell'
export { default as AssetsShell, AssetsPageHeader } from './assetsShell'
export { useAccountHeaderActions } from './accountShell/accountHeaderActions'
export {
  buildAccountNav,
  resolveActiveNavId,
  ACCOUNT_MAIN_SECTION_KEYS,
  SECURITY_INNER_KEYS,
  VERIFY_INNER_KEYS,
  SETTING_INNER_KEYS,
} from './config/accountNav'
export {
  buildAssetsNav,
  resolveActiveAssetsNavId,
  ASSETS_MAIN_SECTION_KEYS,
} from './config/assetsNav'
export { default as SiteFooter } from './siteFooter'
